import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const usePageTitle = () => {
    const { mid } = useParams<{ mid: string }>();
    const { t } = useTranslation();
    return t('merchantOverridePageTitle', { mid });
};

export default usePageTitle;
